import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import TagV2 from '@zola/zola-ui/src/components/Tag/TagV2';
import { FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const BannerWrapper = styled.div<{ isLeftAligned: boolean }>`
  width: 100%;
  text-align: ${({ isLeftAligned }) => (isLeftAligned ? 'left' : 'center')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledTag = styled(TagV2)`
  margin-right: ${SPACING.S16};
  height: 20px;
  align-self: center;
`;

export const BannerText = styled.p<{ color: string }>`
  margin: 0;
  color: ${({ color }) => `${color}`};
`;

export const StyledLink = styled(LinkV2)<{ textcolor: string }>`
  margin-left: ${SPACING.S24};
  color: ${({ textcolor }) => `${textcolor}`} !important;
  font-size: ${FONT.FONT_SIZE_SMALLER} !important;
  flex-shrink: 0;
`;
